import { nanoid } from "nanoid";
import { patrolDb, type AiQueryRecord } from "../lib/db";

export interface CommonQuestion {
  question: string;
  count: number;
  lastAskedAt: string;
  lastAnswer: string;
}

export async function recordAiQuery(params: { question: string; answer: string; sql: string; rowCount: number }) {
  await patrolDb.open();
  const record: AiQueryRecord = {
    id: nanoid(),
    question: params.question,
    answer: params.answer,
    sql: params.sql,
    createdAt: new Date().toISOString(),
    rowCount: params.rowCount
  };
  await patrolDb.aiQueries.put(record);
  return record;
}

export async function fetchRecentAiQueries(limit = 5) {
  await patrolDb.open();
  return patrolDb.aiQueries.orderBy("createdAt").reverse().limit(limit).toArray();
}

export async function fetchCommonQuestions(limit = 4): Promise<CommonQuestion[]> {
  await patrolDb.open();
  const all = await patrolDb.aiQueries.toArray();
  const counts = new Map<string, { count: number; lastAskedAt: string; lastAnswer: string }>();
  for (const entry of all) {
    const stats = counts.get(entry.question) ?? { count: 0, lastAskedAt: entry.createdAt, lastAnswer: entry.answer };
    stats.count += 1;
    if (entry.createdAt > stats.lastAskedAt) {
      stats.lastAskedAt = entry.createdAt;
      stats.lastAnswer = entry.answer;
    }
    counts.set(entry.question, stats);
  }
  return Array.from(counts.entries())
    .sort((a, b) => b[1].count - a[1].count)
    .slice(0, limit)
    .map(([question, stats]) => ({
      question,
      count: stats.count,
      lastAskedAt: stats.lastAskedAt,
      lastAnswer: stats.lastAnswer
    }));
}
